import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-error',
  styleUrls: ['./error.component.scss'],
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
  @Input() public message = '';
  constructor(public readonly translate: TranslateService) {}

  public ngOnInit(): void {
    if (this.message === '') {
      this.translate
        .get('ERRORS.GENERIC')
        .subscribe((text: string) => (this.message = text));
    }
  }
}
